'use client'

import { AbhaLanding } from '@acko-tech/building-blocks.ui.abha-landing'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { getAbhaJourneyUrl } from '@helpers/abhaWidgetHelper'
import { TAP_BTN_EVENT } from '@components/Product/ProductWidget/constants'
import StyledComponentsRegistry from '@configs/registry'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import { useUserData } from '@utils/userUserData'
import { useUserContext } from '@context/UserContext/UserContenxt'
import { AbhaRootContainer } from './abhaWidgetStyles'
import { ABHA_WIDGET_LOGO } from './constants'
import { AbhaWidgetProps } from './interfaces'

const AbhaWidget = ({ widgetOptions, segmentEventCommonProperties, modalOpen = false }: AbhaWidgetProps) => {
  const { isLoggedIn } = useUserContext()
  const userData = useUserData(isLoggedIn)

  const redirectToJourney = async (_e, { phone, aadhar }) => {
    const properties = await segmentEventCommonPropFunc(segmentEventCommonProperties)

    await trackEvent(TAP_BTN_EVENT, {
      ...properties,
      phone,
    })

    window.location.href = getAbhaJourneyUrl(phone, aadhar)
  }

  return (
    <StyledComponentsRegistry>
      <AbhaRootContainer id="AbhaRootContainer" setMaxWidth={modalOpen}>
        <AbhaLanding
          onClick={redirectToJourney}
          logo={ABHA_WIDGET_LOGO}
          title={widgetOptions?.widgetTitle}
          CTAText={widgetOptions?.widgetCtaText}
          phoneNumberPlaceholder={widgetOptions?.phonePlaceholder}
          aadhaarPlaceholder={widgetOptions?.aadhaarPlaceholder}
          phoneNumberDesc={widgetOptions?.phoneDesc}
          aadhaarDesc={widgetOptions?.aadhaarDesc}
          userData={userData}
        />
      </AbhaRootContainer>
    </StyledComponentsRegistry>
  )
}

export default AbhaWidget
